<template>
    <u-text-field-filled-tile v-model="modelValue" v-bind="$attrs" @input="emit" @search="$emit('search')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-text-field-filled-tile>
</template>

<script>
import UTextFieldFilledTile from "@/components/publish/styles/forms/u-text-field-filled-tile.vue";

export default {
    components: {
        UTextFieldFilledTile,
    },
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        modelValue: null,
    }),
    methods: {
        sync() {
            this.modelValue = this.value;
        },
        emit() {
            this.$emit("input", this.modelValue);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
